import { useVendorUserQuery } from '../_gen/gql'
import useGqlClient from './useGqlClient'

const useVendorUser = (vendorId: string, vendorUserId?: string) =>
  useVendorUserQuery({
    variables: { vendorId, vendorUserId: vendorUserId ?? null },
    client: useGqlClient(),
  })

type User = NonNullable<ReturnType<typeof useVendorUserQuery>['data']>['vendorUser']

export type { User }
export default useVendorUser
